import React, { useState, useMemo, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import './style.css';
import { ReactComponent as ModalLogo } from './modal-logo.svg';
import ModelAlert from './ModelAlert';
import { useAuth } from '../../../../hooks/useAuth';
import { closePost } from '../../../../firebase/api/post';
import { sendGridEmail } from '../../../../firebase/api/mail';
import { getReviewersEmails } from '../../../../firebase/api/review';
import { TEMPLATE_ID } from '../../../../constants/templates';

const EmailAllModal = ({ isOpen, postId, onToggle, onPoseClosed }) => {
    const { currentUser } = useAuth();

    const defaultComment = useMemo(() => {
        return `Thank you for your comment. 
I really appreciate your time and effort in helping me.
                
All the best,

${currentUser.firstName}`;
    }, [currentUser.firstName]);

    const [comment, setComment] = useState(defaultComment);

    const handleCommentChange = useCallback(({ target }) => {
        setComment(target.value);
    }, []);

    const handleSendButtonClick = useCallback(async () => {
        await closePost(postId);
        const emails = await getReviewersEmails(postId);

        sendGridEmail({
            subject: `${currentUser.firstName} wants to thank you.`,
            sendTo: emails,
            templateId: TEMPLATE_ID.DEFAULT_EMAIL,
            body: comment,
        });
        onToggle();
        if (onPoseClosed) {
            onPoseClosed();
        }
    }, [onPoseClosed, onToggle, postId, currentUser, comment]);

    return (
        <Modal isOpen={isOpen} toggle={onToggle} className="validate-modal">
            <ModalHeader toggle={onToggle}>
                <ModalLogo />
                <span className="ml-3">
                    Thank <b>everyone</b>
                </span>
            </ModalHeader>
            <ModalBody>
                <ModelAlert />
                <div className="email-all__container">
                    <textarea value={comment} onChange={handleCommentChange} />
                    <input
                        type="button"
                        className="ml-3 email-all__submit"
                        onClick={handleSendButtonClick}
                        value="Send"
                    />
                </div>
            </ModalBody>
        </Modal>
    );
};

EmailAllModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    postId: PropTypes.string.isRequired,
    onToggle: PropTypes.func.isRequired,
    onPoseClosed: PropTypes.func,
};

export default React.memo(EmailAllModal);
